export function capitalize(value) {
	const [c, ...s] = value;
	return [c.toUpperCase(), ...s.map(e => e.toLowerCase())].join('');
}